module.exports = __webpack_public_path__ + "img/ever.7005ff7e.svg";